import React from 'react';
import {Modal} from 'react-bootstrap';

const DeleteEventModal = (props)=>{
    const {event, onHide, onConfirm} = props;
    return (
        <Modal
            show={true}
            onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Eliminar evento</Modal.Title>
            </Modal.Header>
            <Modal.Body >
                <p>¿Estás seguro que deseas eliminar el evento&nbsp;<strong>{event.name}</strong>?</p>
                <p>Esta acción no se puede deshacer.</p>
            </Modal.Body>
            <Modal.Footer>
                <button onClick={ onHide } className='btn btn-primary pull-left'>Cancelar</button>
                <button className='btn btn-danger' onClick={ ()=>onConfirm( event ) }>Eliminar</button>
            </Modal.Footer>
        </Modal>
    );
};

export default DeleteEventModal;


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/Events/components/DeleteEventModal/index.jsx